// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__sEh3q","ranges":"BmiRanges_ranges__3tCKL"};